/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_ReplyInputs */

const en_metadata_merge_reply = /** @type {(inputs: Metadata_Merge_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply`)
};

const fr_metadata_merge_reply = /** @type {(inputs: Metadata_Merge_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répondre`)
};

const de_metadata_merge_reply = /** @type {(inputs: Metadata_Merge_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwort`)
};

const it_metadata_merge_reply = /** @type {(inputs: Metadata_Merge_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rispondere`)
};

const ru_metadata_merge_reply = /** @type {(inputs: Metadata_Merge_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отвечать`)
};

const es_metadata_merge_reply = /** @type {(inputs: Metadata_Merge_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responder`)
};

const zh_cn2_metadata_merge_reply = /** @type {(inputs: Metadata_Merge_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回复`)
};

const ja_metadata_merge_reply = /** @type {(inputs: Metadata_Merge_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返事`)
};

const hi_metadata_merge_reply = /** @type {(inputs: Metadata_Merge_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जवाब`)
};

const pt_pt2_metadata_merge_reply = /** @type {(inputs: Metadata_Merge_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responder`)
};

/**
* | output |
* | --- |
* | "Reply" |
*
* @param {Metadata_Merge_ReplyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_reply = /** @type {((inputs?: Metadata_Merge_ReplyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_ReplyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metadata_merge_reply(inputs)
	if (locale === "de") return de_metadata_merge_reply(inputs)
	if (locale === "it") return it_metadata_merge_reply(inputs)
	if (locale === "ru") return ru_metadata_merge_reply(inputs)
	if (locale === "es") return es_metadata_merge_reply(inputs)
	if (locale === "zh-CN") return zh_cn2_metadata_merge_reply(inputs)
	if (locale === "ja") return ja_metadata_merge_reply(inputs)
	if (locale === "hi") return hi_metadata_merge_reply(inputs)
	if (locale === "pt-PT") return pt_pt2_metadata_merge_reply(inputs)
	return en_metadata_merge_reply(inputs)
});